import { ExtendedMedia } from '@seen/core/models/Media'
import type { JSX } from 'react'
import { Loader } from '#src/components/core/Loader.tsx'
import { Helmet } from '#src/components/Helmet.tsx'
import { MemoriesGrid } from '#src/components/memories/MemoriesGrid.tsx'
import { useCurrentParticipant } from '#src/contexts/current-participant/useCurrentParticipant.ts'
import { useSearch } from '#src/hooks/useSearch.ts'

const EMPTY_MEDIA: ExtendedMedia[] = []

export function MemoriesPage(): JSX.Element {
  const participant = useCurrentParticipant()

  const { data: media = EMPTY_MEDIA, isLoading } = useSearch(
    ExtendedMedia,
    participant
      ? ExtendedMedia.searchQueryForPatient(participant.id)
      : undefined
  )

  if (isLoading) {
    return <Loader />
  }

  if (!participant) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-muted-foreground">No participant selected</p>
      </div>
    )
  }

  return (
    <>
      <Helmet title={`${participant.name} - Memories`} />
      <div className="space-y-6">
        <h1 className="text-2xl font-semibold">
          Memories created with {participant.name}
        </h1>

        <MemoriesGrid media={media} />
      </div>
    </>
  )
}
